import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IgeneralResponse03 } from '../app/Interfaces/igeneralresponse02';
import { CommanderCancel, IGRPASInProduction, IGRPASOptions, IOrderId, IRCommanderHList } from '../app/Interfaces/iproduction';
import { environment } from '../environments/environment';
import { DataService } from './data.service';
import { RDataTable } from '../app/Interfaces/idatatable';

@Injectable()
export class ProductionService {
  private baseUrl = environment.urlAPI;

  constructor(private http: HttpClient, private dataService: DataService) { }

  public CancelCommander(Data: CommanderCancel) {
    try {
      let url = this.baseUrl + 'api/commander/cancel/v1/';
      return this.dataService.put<IgeneralResponse03>(url,Data).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e.message);
    }
  }

  public GetCommanderStates()
  {
    try {
      let url = this.baseUrl + 'api/commander/v1/states/';
      return this.dataService.get<RDataTable>(url).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e.message);
    }

  }
 
  public GetCommanderHList(CCId: number, Zone: number, SrvLocationId: number, AttendingUserId: number, Status: string, StartDate:string, EndDate: string)
  {
    try {
      let url = this.baseUrl + 'api/commander/v1/headerlist/';
      return this.dataService.get<IRCommanderHList>(url + CCId + "/" + Zone + "/" + SrvLocationId + "/" + AttendingUserId + "/" + Status + "/" + StartDate + "/" + EndDate).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e.message);
    }
  }

  public GetPASinProductionV2(PrdLocationId: number, SrvLocationServiceId: number) {
  try {
    let url = this.baseUrl + 'api/production/v2/pasinproduction/';
    return this.dataService.get<IGRPASInProduction>(url +PrdLocationId+"/"+SrvLocationServiceId).
      pipe(res => { return res });
  }
  catch (e) {
    console.log(e.message);
  }
}


  public GetPASOptions(PTextOption: string) {
    try {
      let url = this.baseUrl + 'api/production/v1/pasoptions/';
      if (PTextOption.length == 0) PTextOption = "*";
      return this.dataService.get<IGRPASOptions>(url+PTextOption.trim()).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e.message);
    }
  }

  public PutOrderOut(POrderId: IOrderId) {
    try {
      let url = this.baseUrl + 'api/production/v1/commander/orderOut/';
      return this.dataService.put<IgeneralResponse03>(url, POrderId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e.message);
    }
  }

  public PutOrderIn(POrderId: IOrderId) {
    try {
      let url = this.baseUrl + 'api/production/v1/commander/orderIn/';
      return this.dataService.put<IgeneralResponse03>(url, POrderId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e.message);
    }
  }

  public PutOrderinProduction(POrderId: IOrderId) {
    try {
      let url = this.baseUrl + 'api/production/v1/commander/orderinproduction/';
      return this.dataService.put < IgeneralResponse03 > (url, POrderId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e.message);
    }
  }

  public GetPASinProduction(PLocationId: number) {
    try {
      let url = this.baseUrl + 'api/production/v1/commander/inproduction/';
      return this.dataService.get<IGRPASInProduction>(url + PLocationId).
        pipe(res => { return res });
    }
    catch (e) {
      console.log(e.message);
    }
  }




}
